// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__oA41j","section":"styles_section__eIFaD","logOutBtn":"styles_logOutBtn__OoAzO","deleteBtn":"styles_deleteBtn__AaGxg"};